<template>
  <div id="profit_setting">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <div id ="profit_area">
            <h2 class="title">お客様価格表示</h2>
            <section>
              <ul class="profit_list">
                <li>設定した販売価格率で価格を表示する機能です。</li>
                <li>カスタマイズ画面、図面/見積りダイアログの価格が販売価格となります。</li>
                <li>＊カート画面以降はネット価格です。</li>
              </ul>
            </section>
            <section>
              <ul class="profit_list">
                <li style="font-weight: bold;">※ 注意事項 ※</li>
                <li>1.カート画面より出力される見積り書は<span class="pickup">ネット価格が表示</span>されます。</li>
                <li>2.販売価格率の設定は管理者権限が必要です。</li>
              </ul>
            </section>
            <section id="setting">
              <div class="setting_param">
                <h2>販売価格率の設定</h2>
                <div class="profit_input_field">
                  <div>商品価格</div>
                  <input class="profit_input" type="text" v-model="profitPercentProduct" @keypress="validateNumber" @input="profitPercentProduct=convertHalfNumber($event)" oninput="if(value.length>3)value=value.slice(0,3)" :disabled="!isAdmin">
                  <div>%</div>
                </div>
                <div class="profit_input_field">
                  <div>組立設置費</div>
                  <input class="profit_input" type="text" v-model="profitPercentConstruct" @keypress="validateNumber" @input="profitPercentConstruct=convertHalfNumber($event)" oninput="if(value.length>3)value=value.slice(0,3)" :disabled="!isAdmin">
                  <div>%</div>
                </div>
                <div class="profit_input_field">
                  <div>事前現場調査費</div>
                  <input class="profit_input" type="text" v-model="profitPercentResearch" @keypress="validateNumber" @input="profitPercentResearch=convertHalfNumber($event)" oninput="if(value.length>3)value=value.slice(0,3)" :disabled="!isAdmin">
                  <div>%</div>
                </div>
              </div>
            </section>
            <section>
              <ul class="profit_list">
                <li>※ 計算説明</li>
                <li>販売価格率が<span style="font-weight: bold;">130%</span>の場合、ネット価格が<span style="font-weight: bold;">10,000円</span>（税抜）であれば、</li>
                <li>表示価格は&nbsp;<span style="font-weight: bold;">13,000円</span>（税抜）となります。</li>
                <li><br/></li>
                <li>商品価格⇒商品価格、配送料に適用</li>
                <li>組立設置費⇒組立技術料に適用</li>
                <li>事前現場調査費⇒事前現場調査費に適用</li>
              </ul>
            </section>
            <div class="profit_btn">
              <div class="main_btn sel_main_btn" @click="apply()">
                <a>反映する</a>
              </div>
            </div>
          </div>
          <!-- ローディングモーダル -->
          <dd-loading-modal ref="loadingModalRef" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import {USER_TYPE} from '../constants/TypeEc'
import DcHeader from '../components/common/DcHeader'
import DDLeftMenu from '../components/top/DcLeftMenu'
import LoadingModal from '../components/common/LoadingModal'
import DcSiteMap from '../components/common/DcSiteMap'
import ToolTip from '../../components/common/ToolTip'
import * as FormUtil from '../../utils/FormUtil'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-menu': DDLeftMenu,
    'dd-loading-modal': LoadingModal,
    'tool-tip': ToolTip,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcMyPage',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'mypage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'dcProfitSetting', key: 'dcProfitSetting', title: 'お客様価格表示', route: 'DcProfitSetting'}
      ],
      profitPercentProduct: 0,
      profitPercentConstruct: 0,
      profitPercentResearch: 0,
      userInfo: {},
      imgQmark: this.getImage('common/qmark_gray.svg')
    }
  },
  methods: {
    apply: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        profitPercentProduct: this.profitPercentProduct,
        profitPercentConstruct: this.profitPercentConstruct,
        profitPercentResearch: this.profitPercentResearch
      }
      let _this = this
      axios.post(DC_URL.TOP + '/profit/white', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            App.setLocalStorage(DC_STORAGE_KEY.USER_INFO, _this.userInfo)
            this.confirmDialog()
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    read: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(DC_URL.TOP + '/profit/read')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.profitPercentProduct = response.data.data.profitPercentProduct
            this.profitPercentConstruct = response.data.data.profitPercentConstruct
            this.profitPercentResearch = response.data.data.profitPercentResearch
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    convertHalfNumber: function (event) {
      let str = FormUtil.restHalfNumber(event.target.value)
      return str
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return ret
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    confirmDialog: function () {
      App.showModal({
        title: '',
        messages: ['反映されました'],
        messageType: 'success',
        layoutType: 'layout-classic',
        modalType: 'confirm',
        textAlign: 'center',
        okBtnLabel: '閉じる',
        cancelBtnLabel: 'TOPへ戻る',
        onOk: () => {
          // 特になし
        },
        onCancel: () => {
          this.$router.push('/mmstyle/top')
        }
      })
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  computed: {
    isAdmin: function () {
      return (this.userInfo.userType === USER_TYPE.DC_ADMIN.code)
    }
  },
  mounted: function () {
    this.read()
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dc-profit.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcProfitSetting.vue